import clsx from "clsx";
import {React} from "react";
import CustomEmptyFont from "../../../../components/CustomEmptyFont";

function MarginStatementHeaderItem({title,value,loading}){
    return <div  className={clsx(
        "custom-card-content-settlement-item-container d-flex align-items-center justify-content-start",
    )}>
        <h4 className="m-0" style={{minWidth: "150px"}}>{title}</h4>
        <CustomEmptyFont variant='span' value={loading ? '-' : value} className="mx-2"></CustomEmptyFont>
    </div>
}

export default MarginStatementHeaderItem
